import { Component, inject, OnInit } from '@angular/core';
import { WealthNavigationService } from '@client-monorepo/wealth/navigation';
import { RouteStateService } from '@client-monorepo/common/utilities';
import { NgxButtonComponent } from '@digipay/ngx-button';

import { NgxAppBarComponent } from '@digipay/ngx-app-bar';
import { WALLETS_ROUTE } from '../../../../data-access/constants/app-routes';

@Component({
  selector: 'app-campaign-shahkar-error',
  templateUrl: './campaign-shahkar-error.component.html',
  styleUrls: ['./campaign-shahkar-error.component.scss'],
  standalone: true,
  imports: [NgxButtonComponent, NgxAppBarComponent],
})
export class CampaignShahkarErrorComponent implements OnInit {
  state:
    | {
        type?: 'FixedIncome';
        symbol?: '';
        amount?: 0;
        unitCount?: 0;
        phoneNumber?: 0;
        walletId: '';
        walletName: '';
      }
    | undefined;
  private navigationService = inject(WealthNavigationService);
  private routeState = inject(RouteStateService);

  ngOnInit(): void {
    this.state = this.routeState.getAll();
  }

  onBackHandler() {
    if (this.state?.walletName) {
      this.navigationService.navigate([WALLETS_ROUTE, this.state.walletId.toLowerCase()]);
    } else {
      window.history.back();
    }
  }
}
